export const BANNER_HEIGHT = 160;
